// @ts-nocheck
import React, { useState } from "react";
import { AgregarListaModal } from "./AgregarListaModal";
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import anadirIcono from '../../../Iconos/anadir_lista.png';

export const AgregarListaButton = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => { setOpen(true); };
    const handleClose = () => { setOpen(false); };

    return (
        <div>
            <Tooltip title="Crear Lista">
                <Fab
                    sx={{
                        backgroundColor: "#B71234",
                        '&:hover': { backgroundColor: "#C5415C" }
                    }}
                    onClick={handleOpen}
                    ria-label="add">
                    <img alt="icono de añadir" src={anadirIcono} width="55%" height="55%" />
                </Fab>
            </Tooltip>
            <AgregarListaModal
                open={open}
                onClose={handleClose}
            />
        </div>
    )
};